module.exports = __webpack_public_path__ + "static/media/DSCF0067.ff1a565d.jpg";